import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import MyelinersTab from './components/MyelinersTab';
import AdditionalDetailsTab from './components/AdditionalDetailsTab';
import BankInfoTab from './components/BankInfoTab';
import TaskCommentsTab from './components/TaskCommentsTab';
import TaskAttachmentsTab from './components/TaskAttachmentsTab';
import DocumentManagerTab from './components/DocumentManagerTab';
import LeavesTab from './components/LeavesTab';
import ClaimsTab from './components/ClaimsTab';
import PayslipsTab from './components/PayslipsTab';
import ProgressReportsTab from './components/ProgressReportsTab';
import GameTestingTab from './components/GameTestingTab';
import BugReportsTab from './components/BugReportsTab';
import EmployeeRewardTab from './components/EmployeeRewardTab';
import './DomainMigration.scss';

const DomainMigration = () => {
  const { user, isAdmin } = useSelector(state => state.auth);
  const [activeTab, setActiveTab] = useState('myeliners');

  // List of all tabs
  const tabs = [
    { id: 'myeliners', label: 'Myeliners' },
    { id: 'additionalDetails', label: 'Additional Details' },
    { id: 'bankInfo', label: 'Bank Info' },
    { id: 'assignedTasks', label: 'Assigned Tasks' },
    { id: 'taskComments', label: 'Task Comments' },
    { id: 'taskAttachments', label: 'Task Attachments' },
    { id: 'documentManager', label: 'Document Manager' },
    { id: 'leaves', label: 'Leaves' },
    { id: 'claims', label: 'Claims' },
    { id: 'payslips', label: 'Payslips' },
    { id: 'progressReports', label: 'Progress Reports' },
    { id: 'gameTesting', label: 'Game/App Testing' },
    { id: 'bugReports', label: 'Bug Reports' },
    { id: 'employeeReward', label: 'Employee Reward' },
  ];

  // Handle tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  // Tab content components
  const renderTabContent = () => {
    switch (activeTab) {
      case 'myeliners':
        return <MyelinersTab />;
      case 'additionalDetails':
        return <AdditionalDetailsTab />;
      case 'bankInfo':
        return <BankInfoTab />;
      case 'taskComments':
        return <TaskCommentsTab />;
      case 'taskAttachments':
        return <TaskAttachmentsTab />;
      case 'documentManager':
        return <DocumentManagerTab />;
      case 'leaves':
        return <LeavesTab />;
      case 'claims':
        return <ClaimsTab />;
      case 'assignedTasks':
        return <div className="tab-content-placeholder">Assigned Tasks migration content will go here</div>;
      case 'payslips':
        return <PayslipsTab />;
      case 'progressReports':
        return <ProgressReportsTab />;
      case 'gameTesting':
        return <GameTestingTab />;
      case 'bugReports':
        return <BugReportsTab />;
      case 'employeeReward':
        return <EmployeeRewardTab />;
      default:
        return <div className="tab-content-placeholder">Select a tab to view migration options</div>;
    }
  };

  if (!isAdmin) {
    return (
      <div className="domain-migration-container">
        <div className="access-denied">
          <h3>Access Denied</h3>
          <p>You do not have permission to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="domain-migration-container">
      <div className="domain-migration-header">
        <h1>Domain Migration</h1>
        <p>Manage email domain migration from myelinh.com to myelinz.com</p>
      </div>
      
      <div className="domain-migration-tabs">
        <div className="tabs-header">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabChange(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default DomainMigration; 